import { ColorGradient, CustomThemeColors, CustomThemes } from '../../libs/charting_library/charting_library/charting_library';
import { CONFIGURABLE_DETAILS } from './constants';

/** TradingView default light theme (bundled charting library palette). */
const TRADINGVIEW_DEFAULT_THEME: CustomThemeColors = {
    color1: [
        '#E3EFFD', '#BBD9FB', '#a6ccfa', '#90BFF9', '#76aef8', '#5B9CF6', '#468bf6', '#3179F5', '#2d6efa',
        '#2962FF', '#245bf2', '#1E53E5', '#1b4ed9', '#1848CC', '#1643c0', '#143EB3', '#1038a6', '#0C3299', '#0C3299',
    ],
    color2: [
        '#F8F9FD', '#F0F3FA', '#E0E3EB', '#D1D4DC', '#C1C4CD', '#B2B5BE', '#A3A6AF', '#9598A1', '#868993',
        '#787B86', '#6A6D78', '#5D606B', '#50535E', '#434651', '#363A45', '#2A2E39', '#1E222D', '#131722', '#0C0E15',
    ],
    color3: [
        '#FFEBEC', '#FCCBCD', '#fbb6b9', '#FAA1A4', '#f98f92', '#F77C80', '#f76770', '#F7525F', '#f54452',
        '#F23645', '#df3341', '#CC2F3C', '#bf2c38', '#B22833', '#a6242e', '#991F29', '#8d1c26', '#801922', '#801922',
    ],
    color4: [
        '#DAF2EE', '#ACE5DC', '#8ed9cd', '#70CCBD', '#59c5b3', '#42BDA8', '#32b49e', '#22AB94', '#15a28b',
        '#089981', '#078d76', '#06806B', '#067361', '#056656', '#035a4b', '#004D40', '#004035', '#00332A', '#00332A',
    ],
    color5: [
        '#FFF3E0', '#FFE0B2', '#ffd699', '#FFCC80', '#ffc267', '#ffb74d', '#ffaf3a', '#FFA726', '#ffa013',
        '#FF9800', '#fd9200', '#FB8C00', '#f88400', '#F57C00', '#f27400', '#EF6C00', '#eb5f00', '#e65100', '#e65100',
    ],
    color6: [
        '#F3E5F5', '#E1BEE7', '#d8a9e0', '#CE93D8', '#c47ed0', '#ba68c8', '#b358c2', '#ab47bc', '#a437b6',
        '#9c27b0', '#9526ad', '#8e24aa', '#8522a6', '#7b1fa2', '#731d9e', '#6A1B9A', '#5a1893', '#4A148C', '#4A148C',
    ],
    color7: [
        '#FFF9C4', '#FFF9C4', '#fff7b1', '#FFF59D', '#fff38a', '#FFF176', '#fff067', '#ffee58', '#ffed4a',
        '#ffeb3b', '#fee238', '#fdd835', '#fccc31', '#fbc02d', '#fab429', '#f9a825', '#f7941e', '#F57F17', '#F57F17',
    ],
    white: '#ffffff',
    black: '#000000',
};

export function getTradingViewCustomThemes(): CustomThemes {
    const theme = {
        ...TRADINGVIEW_DEFAULT_THEME,
        color1: buildColor1FromPrimary(CONFIGURABLE_DETAILS.primaryColorTradingView),
    };

    return { light: theme, dark: theme };
}

function buildColor1FromPrimary(primaryColor: string): ColorGradient {
    const shades: string[] = [];

    for (let i = 0; i < 19; i++) {
        if (i < 9) {
            shades.push(mix('#ffffff', primaryColor, i / 9));
        } else if (i === 9) {
            shades.push(primaryColor);
        } else {
            shades.push(mix(primaryColor, '#000000', (i - 9) / 9));
        }
    }

    return shades as ColorGradient;
}

function mix(a: string, b: string, ratio: number): string {
    const [r1, g1, b1] = parseHex(a);
    const [r2, g2, b2] = parseHex(b);
    const t = Math.min(Math.max(ratio, 0), 1);

    return `#${[
        Math.round(r1 + (r2 - r1) * t),
        Math.round(g1 + (g2 - g1) * t),
        Math.round(b1 + (b2 - b1) * t),
    ].map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}

function parseHex(hex: string): [number, number, number] {
    const value = hex.replace('#', '').length === 3
        ? hex.replace('#', '').split('').map((c) => c + c).join('')
        : hex.replace('#', '');

    return [
        parseInt(value.slice(0, 2), 16),
        parseInt(value.slice(2, 4), 16),
        parseInt(value.slice(4, 6), 16),
    ];
}
